import { IDocumentationState, State } from "processEditor/model/State";
import * as React from "react";
import { connect } from "react-redux";
import { InlineLoadSpinner } from "shared/components/PageLoadSpinner";
import { Utilities } from "shared/utilities";

const DocumentationPanel: React.FC<DocumentationPanelProps> = (props) => {

    const [documentation, setDocumentation] = React.useState<string | null>(null);
    React.useEffect(() => {
        const fetchData = async () => {
            try {
                const article = await Utilities.getFetchAsText(`api/documentation/${props.documentation?.type}/${props.documentation?.identifier}`);
                setDocumentation(article);
            } catch (e) {
                console.warn(e);
            }
        }

        if (props.documentation?.identifier && props.documentation?.type) {
            fetchData();
        }
    }, [props.documentation]);

    return (
        <div>
            <h3>{props.title}</h3>
            {documentation === null ? (
                <InlineLoadSpinner height={64} width={64} />
            ) : (
                <div dangerouslySetInnerHTML={{ __html: documentation }} />
            )}
        </div>
    )
}

interface IDocumentationPanelOwnProps {
    title?: string | null;
}

interface IDocumentationPanelStateProps {
    documentation?: IDocumentationState;
}

export type DocumentationPanelProps = IDocumentationPanelOwnProps & IDocumentationPanelStateProps;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const mapStateToProps = (state: State, ownProps: IDocumentationPanelOwnProps): DocumentationPanelProps => {
    return {
        documentation: state.uiState.documentation
    };
};


export default connect(mapStateToProps)(DocumentationPanel);
